export default function IconCheckedGreen () {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM15.9971 9.06559C15.548 8.61648 14.8198 8.61648 14.3707 9.06559L10.9412 12.4951L9.63309 11.1869C9.18399 10.7378 8.45585 10.7378 8.00675 11.1869C7.55765 11.636 7.55765 12.3641 8.00675 12.8133L10.1281 14.9346C10.5772 15.3837 11.3053 15.3837 11.7544 14.9346L15.9971 10.6919C16.4462 10.2428 16.4462 9.51469 15.9971 9.06559Z"
            fill="#1F9A48"/>
    </svg>

  )
}
